var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{attrs:{"label":_vm.label}},[_c('el-date-picker',_vm._b({staticStyle:{"width":"100%"},attrs:{"type":"datetime","size":"small"},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'el-date-picker',_vm.mOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }